/**
 * Affiliations Module
 */
 import Vue from 'vue';
 import router from '../../../router/router';
 import { apiModel, makeApiRequest } from "../../../api";
 import {store} from "../../store";
 
 // States
 const state = {
     validation_examens: [],
     examen_validations: [],
     validation_prix: [],
     notif_validation_prix: [],
     validation_count: {},
 };
 
 // Getters
 const getters = {
    validation_examens: state => {
         return state.validation_examens
     },
    examen_validations: state => {
        return state.examen_validations
    },
    validation_prix: state => {
         return state.validation_prix
     },
    notif_validation_prix: state => {
        return state.notif_validation_prix
    },
    validation_count: state => {
        return state.validation_count
    }
 };
 
 // Actions
 const actions = {
     getValidationExamens(context, payload) {
         function successCallback(response) {
             context.commit('setValidationExamensHandler', { validations: response.data.examen_validation });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.ValidationExamen.List, localToken, successCallback, errorCallback, payload.errorMessages);
     },
     getValidationSouscripteur(context, payload) {
        function successCallback(response) {
            context.commit('getValidationExamensPrixHandler', { validations: response.data.examen_validation });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ValidationExamen.ListValidationSouscripteur, localToken, successCallback, errorCallback, payload.errorMessages);
    },
     getExamenComplementaireValidation(context, payload) {
        function successCallback(response) {
            context.commit('getValidationExamensHandler', { examen_validations: response.data.examen_validation });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ValidationExamen.ListExamenConsultation, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getExamenValidationPrix(context, payload) {
        function successCallback(response) {
            context.commit('setValidationExamensPrixHandler', { validations: response.data.examen_validation });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ValidationExamen.ListExamenConsultationSouscripteur, localToken, successCallback, errorCallback, payload.errorMessages);
    },
     getValidationExamensCount(context, payload) {
        function successCallback(response) {
            context.commit('getValidationExamenCountsHandler', { validations: response.data.examen_validation });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ValidationExamen.Notif, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    setEtatValidationExamens(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ValidationExamen.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    setEtatValidationExamensSouscripteur(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ValidationExamen.Souscripteur, localToken, successCallback, errorCallback, payload.errorMessages);
    },
     getMessage(context, payload) {
         function successCallback(response) {
             context.commit('getMessageHandler', { message: response.data.message });
         }
 
         function errorCallback(error) {
 
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Get, localToken, successCallback, errorCallback, payload.errorMessages);
 
     },
 
     createMessage(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
 
             router.push({ name: 'chats', params: { chats: response.data.message.slug } });
         }
 
         function errorCallback(error) {
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Create, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     updateMessage(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             store.dispatch('findAndRemove', {name: 'message' });
             router.push({ name: 'chats', params: { chat: response.data.message.slug } });
 
         }
 
         function errorCallback(error) {
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Update, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     deleteMessage(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             store.dispatch('findAndRemove', {name: 'assistant' });
             router.push({ name: 'chats' });
 
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 };
 
 // Mutations
 const mutations = {
    getValidationExamensHandler(state, { examen_validations }) {
         // Update affiliations state
         state.validation_prix = examen_validations;
     },
    setValidationExamensHandler(state, { validations }) {
        // Update affiliations state
        state.validation_examens = validations;
    },
     getValidationExamensPrixHandler(state, { validations }) {
        // Update affiliations state
        state.validation_prix = validations;
    },
    setValidationExamensPrixHandler(state, { validations }) {
        // Update affiliations state
        state.notif_validation_prix = validations;
    },
    getValidationExamenCountsHandler(state, { validations }) {
        // Update affiliations state
        state.validation_count = validations;
    },

    // setEtatValidationExamensHandler(state, { examen_validations }) {
    //     // Update affiliations state
    //     state.validation_examens = examen_validations;
    // },

     getMessageHandler(state, { message }) {
         // Update affiliation state
        //  console.log("message =>", message);
         state.message = message;
     },
 
 };
 
 export default {
     state,
     getters,
     actions,
     mutations
 }